import LBox from "@components/LBox";
import { useHeaderHeight } from "expo-router/react-navigation";
import { Platform } from "react-native";

export default function ScreenHeaderGapAndroidAndWeb() {
  const height = useHeaderHeight();
  return Platform.OS !== "ios" ? <LBox height={height} /> : null;
}
